import { tr } from "../../lib/i18n";
import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { publicApi } from "../../lib/publicApi";
import { useT } from "../../lib/i18n";

export default function PayResultPage() {
  const [params] = useSearchParams();
  const { t } = useT();
  const id = params.get("attempt") || params.get("merchant_order_id") || sessionStorage.getItem("last_payment_attempt");
  const [res, setRes] = useState(null);
  useEffect(() => {
    if (!id) return undefined;
    let n = 0;
    const tick = () => publicApi.get(`/pay-result/${encodeURIComponent(id)}`).then((r) => {
      setRes(r.data);
      if (r.data.status === "Pending" && n++ < 20) timer = setTimeout(tick, 3000);
    }).catch(() => setRes({ status: "Unknown" }));
    let timer = setTimeout(tick, 0);
    return () => clearTimeout(timer);
  }, [id]);
  const status = res?.status || (id ? "Pending" : "Unknown");
  const msg = { Paid: t("pay.result_paid"), Failed: t("pay.result_failed"), Pending: t("pay.result_pending") }[status] || t("pay.result_unknown");
  return (
    <div className="container-x" style={{ maxWidth: 520, margin: "0 auto", padding: "130px 20px 64px" }} data-testid="pay-result-page">
      <h1 style={{ fontSize: 32, fontWeight: 300 }} data-testid="pay-result-status">{t(`pay.status_${status.toLowerCase() /* i18n-keys: paid,failed,pending,unknown */}`)}</h1>
      <p style={{ marginTop: 12 }} data-testid="pay-result-message">{msg}</p>
      {res?.amount && <p style={{ marginTop: 8 }}><span dir="ltr">OMR {res.amount}{res.vehicle ? ` · ${res.vehicle}` : ""}</span></p>}
      <Link to="/cars" className="pub-cta" style={{ marginTop: 24, display: "inline-flex" }} data-testid="pay-result-back">{t("pay.back_to_cars")}</Link>
    </div>
  );
}
